// https://segmentfault.com/a/1190000015782272
import Vue from 'vue'
import Vuex from 'vuex'
import mapStatus from './modules/mapStatus'
import pageStatus from './modules/pageStatus'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // mapStatus,
    // pageStatus
  }
})
